import React, { memo } from 'react';
import { NodeProps, Position } from '@xyflow/react';
import BaseNode from '../BaseNode';
import { typeLabelOf } from '../../nodeCatalog';
import { useTranslation } from 'react-i18next';

/** 데이터 품질 검사 노드 — 오른쪽: 통과 행, 아래(reject-path): 위반 행(_violations 항목 추가) */
const icon = <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" /><path d="M9 12l2 2 4-4" /></svg>;

const QualityNode: React.FC<NodeProps<any>> = ({ data, selected, id, type, ...props }) => {
  const { t } = useTranslation();
  const cfg = data?.config || {};
  const n = (cfg.rules || []).length;
  const mode = cfg.onViolation === 'fail' ? t('workflow:quality.failOnViolation') : cfg.onViolation === 'warn' ? t('workflow:quality.warnOnly') : t('workflow:quality.split');
  return (
    <BaseNode id={id} data={data} selected={selected} type={type} icon={icon} label={data?.label || typeLabelOf('quality')} subtitle={t('workflow:quality.subtitle', { n, mode })}
      handles={{ target: true, source: true, targetPosition: Position.Left, sourcePosition: Position.Right,
        extraHandles: [{ id: 'reject-path', type: 'source', position: Position.Bottom, className: 'reject-handle' }] }}
      {...props} />
  );
};

export default memo(QualityNode);
